import { makeStyles } from "@material-ui/core";

export const HEADER_HEIGHT = 64;
export const DRAWER_WIDTH = 260;
export const DRAWER_WIDTH_CLOSED = 61;

export const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#ffffff",
    color: theme.palette.text.primary,
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
    borderBottom: "1px solid #eef0f3",
    width: `calc(100% - ${DRAWER_WIDTH_CLOSED}px)`,
    marginLeft: DRAWER_WIDTH_CLOSED,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
    marginLeft: DRAWER_WIDTH,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  toolbar: {
    minHeight: HEADER_HEIGHT,
    height: HEADER_HEIGHT,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2.5),
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  logo: {
    height: "52px",
    display: "block",
  },
  dateBlock: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2),
    borderRadius: 999,
    backgroundColor: "#f4f6f8",
    border: "1px solid #eef0f3",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  dateIcon: {
    color: theme.palette.primary.main,
    fontSize: "1.5rem",
  },
  dateText: {
    fontSize: "1.05rem",
    fontWeight: 600,
    color: theme.palette.text.primary,
    whiteSpace: "nowrap",
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  notificationButton: {
    color: "#637381",
  },
  divider: {
    width: "1px",
    height: "28px",
    backgroundColor: "#e6e8eb",
    margin: theme.spacing(0, 0.5),
  },
  profileButton: {
    textTransform: "none",
    borderRadius: "12px",
    padding: theme.spacing(0.5, 1),
    "&:hover": {
      backgroundColor: "rgba(17, 98, 254, 0.06)",
    },
  },
  profileButtonLabel: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  avatar: {
    width: 38,
    height: 38,
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    fontSize: "0.95rem",
    fontWeight: 600,
  },
  userDetails: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    lineHeight: 1.2,
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  name: {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: theme.palette.text.primary,
    whiteSpace: "nowrap",
  },
  role: {
    fontSize: "0.72rem",
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
  },
  caret: {
    color: "#919eab",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  menuPaper: {
    marginTop: theme.spacing(1),
    minWidth: 180,
    borderRadius: "12px",
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.12)",
  },
  menuIcon: {
    minWidth: "34px",
    color: "#637381",
  },
}));
